import axios from '@/lib/axios';
import { PurchaseOrderComment } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0633. 発注案件コメント削除
 * [DELETE] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/purchase_order_comments/:id
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  id: number;
};
const deletePurchaseOrderComment = (props: Props): Promise<PurchaseOrderComment> => {
  return axios.delete(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/purchase_order_comments/${props.id}`
  );
};

export const useDeletePurchaseOrderComment = () => {
  return useMutation({
    mutationFn: deletePurchaseOrderComment,
  });
};
